// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShPU0s {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 24px;
  background-color: var(--surface-neutral-pale);
  border-radius: 6px;
  text-align: left;
  border: none;
  margin-bottom: 12px;
}

.ShPU0s:hover,
.ShPU0s:focus-visible {
  background-color: var(--surface-neutral-subtle);
}

.GRqeRT {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--surface-tertiary-medium);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--bs-white);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.vfQaQB {
  line-height: 1;
}

.tqzDd1 {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.s98oBH {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.clisQu {
  font-size: 15px;
  font-weight: 600;
  color: var(--bs-gray-900);
  margin: 0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bHdtEV {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--bs-orange-600);
}

.xKTGAv {
  font-size: 13px;
  font-weight: 500;
  color: var(--bs-gray-700);
  margin: 0;
  line-height: 1.2;
}

.c9CdEl {
  font-size: 12px;
  color: var(--bs-gray-600);
  margin: 0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 15px;
}

@media (max-width: 768px) {
  .r3tR3E {
    padding: 12px 14px;
    gap: 10px;
  }
  .GRqeRT {
    width: 36px;
    height: 36px;
    font-size: 13px;
  }
  .clisQu {
    font-size: 14px;
  }
  .xKTGAv {
    font-size: 12px;
  }
  .c9CdEl {
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EstablishmentCard/EstablishmentCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".cards {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  padding: 24px;\n  background-color: var(--surface-neutral-pale);\n  border-radius: 6px;\n  text-align: left;\n  border: none;\n  margin-bottom: 12px;\n}\n\n.cards:hover,\n.cards:focus-visible {\n  background-color: var(--surface-neutral-subtle);\n}\n\n.avatar {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: var(--surface-tertiary-medium);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--bs-white);\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.avatarInitials {\n  line-height: 1;\n}\n\n.mainContent {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.headerRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.companyName {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--bs-gray-900);\n  margin: 0;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chevron {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: var(--bs-orange-600);\n}\n\n.distance {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--bs-gray-700);\n  margin: 0;\n  line-height: 1.2;\n}\n\n.address {\n  font-size: 12px;\n  color: var(--bs-gray-600);\n  margin: 0;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 15px;\n}\n\n@media (max-width: 768px) {\n  .card {\n    padding: 12px 14px;\n    gap: 10px;\n  }\n  .avatar {\n    width: 36px;\n    height: 36px;\n    font-size: 13px;\n  }\n  .companyName {\n    font-size: 14px;\n  }\n  .distance {\n    font-size: 12px;\n  }\n  .address {\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cards": `ShPU0s`,
	"avatar": `GRqeRT`,
	"avatarInitials": `vfQaQB`,
	"mainContent": `tqzDd1`,
	"headerRow": `s98oBH`,
	"companyName": `clisQu`,
	"chevron": `bHdtEV`,
	"distance": `xKTGAv`,
	"address": `c9CdEl`,
	"card": `r3tR3E`
};
module.exports = ___CSS_LOADER_EXPORT___;
